import React from 'react';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  '@keyframes bbLoadingPulse': {
    '0%, 100%': { opacity: 0.35 },
    '50%': { opacity: 0.7 }
  },
  wrapper: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f5f2f2'
  },
  logo: {
    width: 64,
    height: 64,
    filter: 'grayscale(100%)',
    animation: '$bbLoadingPulse 1.4s ease-in-out infinite'
  },
  text: {
    margin: '18px 0 0',
    fontSize: 15,
    lineHeight: 1.2,
    fontWeight: 400,
    letterSpacing: '.03em',
    color: '#9a9a9a'
  }
});

// React twin of the pre-React boot splash (public/index.html). Reused as the in-app
// loading state for deep-link routes whose own data fetch would otherwise flash a blank
// page after the boot splash has lifted. Text is hardcoded to match the splash exactly.
const LoadingScreen = () => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper} role='status'>
      <img
        className={classes.logo}
        src='/img/components/header/logo_hive.svg'
        alt='BridgeBee'
      />
      <div className={classes.text}>Loading…</div>
    </div>
  );
};

export default LoadingScreen;
